import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleApiError} from "../../helpers/handleApiError";
import Profile from "../../api/repositories/profile";
import {toast} from "react-toastify";
import {getDashboard, updateUserDeliveryInfo} from "./dashboard";
import { getDeliveryAddresses, updateDeliveryAddress } from './payment';

const initialState = {
  isLoading: false,
};

export const updatePassword = createAsyncThunk(
    "profile/updatePassword",

    async (payload) => {
      try {
        const response = await Profile.update_password(payload);
        toast.success('Password updated successfully')
        return response.data;
      } catch (error) {
        handleApiError(error)
      }
    },
);
export const uploadAvatar = createAsyncThunk(
    "profile/uploadAvatar",
    async (payload, { dispatch }) => {
      try {
        const response = await Profile.upload_avatar(payload);

        toast.success('Avatar upload successfully')

        dispatch(getDashboard());

        return response.data;
      } catch (error) {
        handleApiError(error)
      }
    },
);
export const deleteAvatar = createAsyncThunk(
    "profile/deleteAvatar",
    async ({ dispatch }) => {
      try {
        const response = await Profile.delete_avatar();

        dispatch(getDashboard());

        return response.data;
      } catch (error) {
        handleApiError(error)
      }
    },
);

export const updateProfileData = createAsyncThunk(
    "profile/updateData",
    async (payload, { dispatch }) => {
      try {
        const response = await Profile.update_profile_data(payload);

        toast.success('Data updated successfully')
        dispatch(getDashboard())

        return response.data;
      } catch (error) {
        handleApiError(error)
      }
    },
);

export const updateDeliveryInfo = createAsyncThunk(
  'profile/updateDeliveryInfo',
  async (deliveryData, { dispatch, rejectWithValue, getState }) => {
    try {
      // Convert camelCase frontend field names to snake_case for backend
      const backendFormattedData = {
        full_name: deliveryData.fullName,
        phone_number: deliveryData.phoneNumber,
        email_address: deliveryData.email,
        country: deliveryData.country,
        city: deliveryData.city,
        street_address: deliveryData.streetAddress,
        postal_code: deliveryData.postalCode
      };
      
      // Get the current address ID from state, if available
      const state = getState();
      const currentAddressId = state.dashboard.user.delivery?._id;
      
      // If there's an existing address ID, include it in the request
      if (currentAddressId) {
        backendFormattedData.address_id = currentAddressId;
      }
      
      const response = await Profile.updateDeliveryInfo(backendFormattedData);
      
      // Get the updated address data from the response, or use our formatted data
      const updatedAddress = response.data?.address || {
        ...backendFormattedData,
        _id: currentAddressId || response.data?._id
      };
      
      // Update the user delivery info directly in the dashboard store
      dispatch(updateUserDeliveryInfo(updatedAddress));
      
      toast.success('Delivery information updated successfully');
      
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

export const loadDeliveryAddresses = createAsyncThunk(
  'profile/loadDeliveryAddresses',
  async (_, { dispatch }) => {
    try {
      const addresses = await dispatch(getDeliveryAddresses());
      return addresses.payload || { Addresses: [] };
    } catch (error) {
      console.error("Error in loadDeliveryAddresses:", error);
      return { Addresses: [] }; // Возвращаем пустой массив в случае ошибки
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(uploadAvatar.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(uploadAvatar.fulfilled, (state) => {
          state.isLoading = false;
        });
    builder
        .addCase(updateProfileData.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(updateProfileData.fulfilled, (state) => {
          state.isLoading = false;
        });
    builder
        .addCase(deleteAvatar.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(deleteAvatar.fulfilled, (state) => {
          state.isLoading = false;
        });
    builder
        .addCase(updateDeliveryInfo.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(updateDeliveryInfo.fulfilled, (state) => {
          state.isLoading = false;
          state.success = 'Delivery information updated successfully';
        })
        .addCase(updateDeliveryInfo.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        });
    builder
        .addCase(loadDeliveryAddresses.fulfilled, (state, action) => {
          state.deliveryAddresses = action.payload?.Addresses || [];
        });
  },
});

export default profileSlice.reducer;
